<div class="column-2">
  <div class="col">
    <div class="input-container">
      <label> Waste Profile - Document </label>
      <mat-form-field>
        <div *ngIf="unsignedDocuments?.length > 0">
          <label>
            {{
              unsignedDocuments?.length
                | i18nPlural
                  : {
                      '=1': 'Unsigned PDF',
                      other: 'Unsigned PDFs'
                    }
            }}</label
          >
          <ul>
            <li *ngFor="let unsignedDocument of unsignedDocuments">
              <a [href]="unsignedDocument?.signingLink" target="_blank">{{
                unsignedDocument.documentName
              }}</a>
            </li>
          </ul>
        </div>
        <div>
          <label
            *ngIf="signNowDocuments?.length > 0 || docusignData?.length > 0"
          >
            {{
              signNowDocuments?.length
                | i18nPlural
                  : {
                      '=1': 'Signed PDF',
                      other: 'Signed PDFs'
                    }
            }}
          </label>
          <ul *ngIf="signNowDocuments?.length > 0">
            <li *ngFor="let signNowDocument of signNowDocuments">
              <a [href]="signNowDocument.url" target="_blank">{{
                signNowDocument.name
              }}</a>
            </li>
          </ul>
          <ul *ngIf="docusignData?.length > 0">
            <li *ngFor="let docusign of docusignData">
              <a [href]="docusign.signingLink" target="_blank">{{
                docusign.documentName
              }}</a>
            </li>
          </ul>
        </div>
        <div *ngIf="hasThirdPartyUrl">
          <label> 3rd Party Authorization PDF</label>
          <ul>
            <li>
              <a [href]="hasThirdPartyUrl" target="_blank">
                {{ hasThirdPartyUrl }}</a
              >
            </li>
          </ul>
        </div>
        <div *ngIf="hasThirdPartyAttachment">
          <label> 3rd Party Authorization Attachment</label>
          <ul>
            <li>
              <a [href]="hasThirdPartyAttachment.url" target="_blank">
                {{ hasThirdPartyAttachment.url }}</a
              >
              {{ displayDate(hasThirdPartyAttachment.uploadDate) }}
            </li>
          </ul>
        </div>
        <textarea
          matInput
          matTextareaAutosize
          matAutosizeMinRows="3"
          matAutosizeMaxRows="3"
          [disabled]="true"
        >
        </textarea>
      </mat-form-field>
    </div>
  </div>
  <div class="col">
    <div class="edit-section comment-log">
      <div class="input-container">
        <label> Waste Profile - Attachments </label>
        <mat-form-field>
          <div>
            <ng-template #deleteDialog>
              <div class="service-dialog">
                <h2>Are you sure you want to delete the attachment?</h2>
                <ul>
                  <li *ngIf="!this.deleteFile.additionalAdminSupplement.url">
                    {{ this.deleteFile.additionalAdminSupplement.type }}:
                    <a
                      [href]="this.deleteFile.additionalAdminSupplement.fileUrl"
                      target="_blank"
                    >
                      {{
                        this.deleteFile.additionalAdminSupplement.fileName
                      }}</a
                    >
                    {{
                      displayDate(
                        this.deleteFile.additionalAdminSupplement.uploadDate
                      )
                    }}
                  </li>
                  <li *ngIf="this.deleteFile.additionalAdminSupplement.url">
                    3rd Party Authorization:
                    <a
                      [href]="this.deleteFile.additionalAdminSupplement.url"
                      target="_blank"
                    >
                      {{ this.deleteFile.additionalAdminSupplement.url }}</a
                    >
                    {{
                      displayDate(
                        this.deleteFile.additionalAdminSupplement.uploadDate
                      )
                    }}
                  </li>
                </ul>
                <button
                  mat-icon-button
                  cdkFocusInitial
                  class="close"
                  aria-label="Close dialog"
                  color="accent"
                  [disableRipple]="true"
                  [mat-dialog-close]=""
                >
                  <mat-icon>close</mat-icon>
                </button>
                <div class="remove-modal-button-wrapper">
                  <button
                    mat-stroked-button
                    [mat-dialog-close]=""
                    data-testid="admin-delete-confirmation-dialog-cancel-button"
                  >
                    Cancel
                  </button>
                  <button
                    data-testid="admin-delete-confirmation-dialog-remove-button"
                    mat-flat-button
                    color="accent"
                    class="remove-button"
                    (click)="deleteWasteProfile()"
                  >
                    Delete
                  </button>
                </div>
              </div>
            </ng-template>
            <label *ngIf="labAttachments?.length > 0">
              {{
                labAttachments?.length
                  | i18nPlural
                    : {
                        '=1': 'Lab Analytical Attachment',
                        other: 'Lab Analytical Attachments'
                      }
              }}
            </label>
            <ul>
              <li *ngFor="let labAttachment of labAttachments">
                <a [href]="labAttachment.fileUrl" target="_blank"
                  >{{ labAttachment.type }}: {{ labAttachment.fileName }}</a
                >
                {{ displayDate(labAttachment.uploadDate) }}
              </li>
            </ul>
          </div>
          <div>
            <label *ngIf="safetyDataSheets?.length > 0">
              {{
                safetyDataSheets?.length
                  | i18nPlural
                    : {
                        '=1': 'Safety Data Sheet',
                        other: 'Safety Data Sheets'
                      }
              }}
            </label>
            <ul>
              <li *ngFor="let safetyAttachment of safetyDataSheets">
                <a [href]="safetyAttachment.fileUrl" target="_blank">
                  {{ safetyAttachment.type }}:
                  {{ safetyAttachment.fileName }}</a
                >
                {{ displayDate(safetyAttachment.uploadDate) }}
              </li>
            </ul>
          </div>
          <div>
            <label *ngIf="additionalSupplements?.length > 0">
              {{
                additionalSupplements?.length
                  | i18nPlural
                    : {
                        '=1': 'Additional Supplement',
                        other: 'Additional Supplements'
                      }
              }}
            </label>
            <ul>
              <li *ngFor="let addoitionalAttachment of additionalSupplements">
                <a [href]="addoitionalAttachment.fileUrl" target="_blank">
                  {{ addoitionalAttachment.type }}:
                  {{ addoitionalAttachment.fileName }}</a
                >
                {{ displayDate(addoitionalAttachment.uploadDate) }}
              </li>
            </ul>
          </div>
          <div>
            <label *ngIf="stateAttachments?.length > 0">
              {{
                stateAttachments?.length
                  | i18nPlural
                    : {
                        '=1': 'State Required Document',
                        other: 'State Required Documents'
                      }
              }}
            </label>
            <ul>
              <li *ngFor="let stateAttachment of stateAttachments">
                <a [href]="stateAttachment.fileUrl" target="_blank">
                  {{ stateAttachment.type }}: {{ stateAttachment.fileName }}</a
                >
                {{ displayDate(stateAttachment.uploadDate) }}
              </li>
            </ul>
          </div>
          <div
            *ngIf="
              (hasViewInternalAttachmentPermission$ | async) ||
              (hasUpdateWasteProfilePermission$ | async)
            "
          >
            <label *ngIf="internalOnlyAttachments?.length > 0">
              {{
                internalOnlyAttachments?.length
                  | i18nPlural
                    : {
                        '=1': 'Internal Only Attachment',
                        other: 'Internal Only Attachment'
                      }
              }}
            </label>
            <ul>
              <li
                *ngFor="let internalOnlyAttachment of internalOnlyAttachments"
              >
                <a [href]="internalOnly.fileUrl" target="_blank">
                  {{ internalOnlyAttachment.type }}:
                  {{ internalOnlyAttachment.fileName }}</a
                >
                {{ displayDate(internalOnlyAttachment.uploadDate) }}
              </li>
            </ul>
          </div>
          <div>
            <label
              *ngIf="
                additionalAdminSupplements?.length > 0 ||
                stateInternalAdminAttachments?.length > 0 ||
                hasAdminThirdPartyUrl
              "
            >
              Admin Attachments</label
            >
            <ul>
              <li
                class="admin-supplements"
                *ngFor="let adminSupplements of additionalAdminSupplements"
              >
                <div>
                  <a [href]="adminSupplements.fileUrl" target="_blank">
                    {{ adminSupplements.type }}:
                    {{ adminSupplements.fileName }}</a
                  >
                  {{ displayDate(adminSupplements.uploadDate) }}
                </div>
                <div
                  class="dlt-btn"
                  *ngIf="hasUpdateWasteProfilePermission$ | async"
                >
                  <button
                    mat-button
                    type="button"
                    color="accent"
                    (click)="
                      openDialog(
                        deleteDialog,
                        adminSupplements,
                        'adminSupplement'
                      )
                    "
                  >
                    <mat-icon>delete</mat-icon>
                    Delete
                  </button>
                </div>
              </li>
            </ul>

            <ul>
              <li
                class="admin-supplements"
                *ngFor="let stateInternal of stateInternalAdminAttachments"
              >
                <div>
                  <a [href]="stateInternal.fileUrl" target="_blank">
                    {{ stateInternal.type }}: {{ stateInternal.fileName }}</a
                  >
                  {{ displayDate(stateInternal.uploadDate) }}
                </div>
                <div
                  class="dlt-btn"
                  *ngIf="hasUpdateWasteProfilePermission$ | async"
                >
                  <button
                    mat-button
                    type="button"
                    color="accent"
                    (click)="
                      openDialog(
                        deleteDialog,
                        stateInternal,
                        'stateAttachmentName'
                      )
                    "
                  >
                    <mat-icon>delete</mat-icon>
                    Delete
                  </button>
                </div>
              </li>
            </ul>
            <div *ngIf="hasAdminThirdPartyUrl">
              <ul>
                <li class="admin-supplements">
                  <div>
                    <a [href]="hasAdminThirdPartyUrl.url" target="_blank">
                      {{ '3rd Party Authorization' }}:
                      {{ hasAdminThirdPartyUrl.url }}</a
                    >
                    {{ displayDate(hasAdminThirdPartyUrl.uploadDate) }}
                  </div>
                  <div
                    class="dlt-btn"
                    *ngIf="hasUpdateWasteProfilePermission$ | async"
                  >
                    <button
                      mat-button
                      type="button"
                      color="accent"
                      (click)="
                        openDialog(
                          deleteDialog,
                          hasAdminThirdPartyUrl,
                          'thirdParty'
                        )
                      "
                    >
                      <mat-icon>delete</mat-icon>
                      Delete
                    </button>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div
            *ngIf="
              (hasViewInternalAttachmentPermission$ | async) ||
              (hasUpdateWasteProfilePermission$ | async)
            "
          >
            <label *ngIf="internalAdminAttachments.length > 0">
              Internal Attachments</label
            >
            <ul>
              <li
                class="admin-supplements"
                *ngFor="let internalOnly of internalAdminAttachments"
              >
                <div>
                  <a [href]="internalOnly.fileUrl" target="_blank">
                    {{ internalOnly.type }}: {{ internalOnly.fileName }}</a
                  >
                  {{ displayDate(internalOnly.uploadDate) }}
                </div>
                <div
                  class="dlt-btn"
                  *ngIf="hasUpdateWasteProfilePermission$ | async"
                >
                  <button
                    mat-button
                    type="button"
                    color="accent"
                    (click)="
                      openDialog(deleteDialog, internalOnly, 'internalOnlyName')
                    "
                  >
                    <mat-icon>delete</mat-icon>
                    Delete
                  </button>
                </div>
              </li>
            </ul>
          </div>
          <textarea
            matInput
            matTextareaAutosize
            matAutosizeMinRows="3"
            matAutosizeMaxRows="3"
            [disabled]="true"
          >
          </textarea>
        </mat-form-field>
      </div>
    </div>
  </div>
</div>
